// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-list-item.h-38 {\r\n  min-height: 38px;\n}\r\n", ""]);
// Exports
module.exports = exports;
